<template>
  <div v-if="isDropdownOpen" class="z-10 bg-white rounded-lg shadow w-35" ref="contextMenu">
    <ul class="py-2 font-sans font-light">
      <li
        v-for="(option, index) in options"
        class="flex items-center gap-2 px-4 py-2 text-xs cursor-pointer hover:bg-theme-50"
        :class="[option.action == 'delete' ? 'border-t' : '', option.color]"
        :key="index"
        @click.stop="onOptionClick(option.action)">
        <Icon :icon="option.icon" class="h-5 min-w-5" />
        {{ $t(option.name) }}
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { Icon } from '@iconify/vue';
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

type contextMenuOptions = {
  name: string;
  action: string;
  icon: string;
  color?: string;
};

defineProps<{
  isDropdownOpen: boolean;
  options: contextMenuOptions[];
}>();

const emit = defineEmits(['action', 'close']);

function onOptionClick(action: string) {
  emit('action', action);
}

const contextMenu = ref(null);

onClickOutside(contextMenu, () => emit('close'));
</script>
